import fetch from 'cross-fetch';
import config from './config';

function showResponse(response){
    let feedbackElement = document.getElementById("GroupFeedback")
    feedbackElement.classList.add('d-block')
    if (response.errors === undefined){
        feedbackElement.textContent = "You request has been Submitted! \nOur Representative will call back :)"
        feedbackElement.innerHTML = feedbackElement.innerHTML.replace(/\n\r?/g, '<br />');
        feedbackElement.classList.add   ('is-valid')
    }
    else {
        console.log(response.errors.message);
        feedbackElement.textContent = response.errors[0].message
    }   


}

function sendData(name, phoneNo, target){
    fetch(config.API_URL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query: `mutation {
                        updateContact(name: "${name}", phoneNumber: "${phoneNo}"){
                            contact{	
                            name,
                            phoneNumber
                            }
                        }
                    }`,
        }),
    }).then(response => {
        return response.json()
    }).then(response => {
        target.disabled = false;
        showResponse(response)
    })
}

document.addEventListener('click', function (e) {
    if (e.target && e.target.id == 'submitForm') {
        console.log("Hello World!!!")
        let nameNode = document.getElementById("Name");
        let phoneNoNode = document.getElementById("PhoneNo");

        // nameNode.disabled = true;
        // phoneNoNode.disabled = true;
        e.target.disabled = true;

        let name = nameNode.value;
        let phoneNo = phoneNoNode.value;

        sendData(name, phoneNo, e.target);

    }
});

export default `
    <div class="input-group">
        
        <input type="text" id="Name" class="form-control" placeholder="Name">
        <input type="tel" id="PhoneNo" class="form-control" placeholder="Phone No">
        <div class="input-group-append">
            <button class="btn" id="submitForm">Submit</button>
        </div>
    </div>
    <div class="invalid-feedback" id="GroupFeedback"></div>

`